import React from "react";

const SVG = ({ iconName, className, ...rest }) => {
  return <img className={className} src={`/${iconName}`} alt={iconName} loading="lazy" {...rest} />;
};

export default SVG;
